import popupTemplate from './kapcsolat-popup.pug';
import kapcsolatServiceModule from './kapcsolat-service';
import KapcsolatPopupController from './kapcsolat-popup-controller';
import 'ui-select';
const MODULE_NAME = 'kapcsolat';
class KapcsolatController {
	constructor(kapcsolatService, $scope, $uibModal) {
		'ngInject';
		this._kapcsolatService = kapcsolatService;
		this._$scope = $scope;
		this._$uibModal = $uibModal;
	}
	showPopup() {
		this._$uibModal.open({
			animation: true,
			template: popupTemplate(),
			controller: KapcsolatPopupController,
			bindToController: true,
			controllerAs: '$ctrl',
			backdrop: 'static',
			keyboard: false
		});

	}
}

export default angular.module(MODULE_NAME, [kapcsolatServiceModule, 'ui.select'])
	.controller('kapcsolatController', KapcsolatController).name;



// WEBPACK FOOTER //
// ./source/applications/kapcsolat/kapcsolat.js